import { render, staticRenderFns } from "./AdditionalFieldSampleControl.vue?vue&type=template&id=06c03b8f&scoped=true&"
import script from "./AdditionalFieldSampleControl.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldSampleControl.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalFieldSampleControl.vue?vue&type=style&index=0&id=06c03b8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c03b8f",
  null
  
)

export default component.exports